export interface BatchStatisticsLendRequest {
  lendDateFrom: string
  lendDateTo: string
  lendTitle: string
  userPersonaleEnabled: boolean
  userGroupEnabled: boolean
  lendFormat: string
  rdoInterlibraryLoan: string
  rdoSetNumber: string
  lendType: string[]
  lendBranchCodeFrom: string
  lendBranchCodeTo: string
  placeCodeFrom: string
  placeCodeTo: string
  areaCodeFrom: string
  areaCodeTo: string
  addressCodeForm: string
  addressCodeTo: string
  userIdFrom: string
  userIdTo: string
  interlibraryLoanCodeFrom: string
  interlibraryLoanCodeTo: string
  yearAgeEnabled: boolean
  xItem: string
  yItem1: string
  yCheck1: boolean[]
  yItem2: string
  yCheck2: boolean[]
  yItem3: string
  yCheck3: boolean[]
  yItem4: string
  yCheck4: boolean[]
  numberEnabled: boolean
  numberOfPeopleEnabled: boolean
  numberOfPeopleActualEnabled: boolean
  isOutputFull: boolean
  lendMemo: string
  batchType: string
}

export function BatchStatisticsLendRequestToJSON(
  value: BatchStatisticsLendRequest
): any {
  return {
    lend_date_from: value.lendDateFrom,
    lend_date_to: value.lendDateTo,
    title: value.lendTitle,
    user_personal_enabled: value.userPersonaleEnabled,
    user_group_enabled: value.userGroupEnabled,
    lend_format: value.lendFormat,
    rdo_interlibrary_loan: value.rdoInterlibraryLoan,
    rdo_set_number: value.rdoSetNumber,
    lend_type: value.lendType,
    lend_branch_code_from: value.lendBranchCodeFrom,
    lend_branch_code_to: value.lendBranchCodeTo,
    place_code_from: value.placeCodeFrom,
    place_code_to: value.placeCodeTo,
    area_code_from: value.areaCodeFrom,
    area_code_to: value.areaCodeTo,
    address_code_from: value.addressCodeForm,
    address_code_to: value.addressCodeTo,
    user_id_from: value.userIdFrom,
    user_id_to: value.userIdTo,
    interlibrary_loan_code_from: value.interlibraryLoanCodeFrom,
    interlibrary_loan_code_to: value.interlibraryLoanCodeTo,
    year_age_enabled: value.yearAgeEnabled,
    x_item: value.xItem,
    y_item1: value.yItem1,
    y_check1: value.yCheck1,
    y_item2: value.yItem2,
    y_check2: value.yCheck2,
    y_item3: value.yItem3,
    y_check3: value.yCheck3,
    y_item4: value.yItem4,
    y_check4: value.yCheck4,
    number_enabled: value.numberEnabled,
    number_of_people_enabled: value.numberOfPeopleEnabled,
    number_of_people_actual_enabled: value.numberOfPeopleActualEnabled,
    is_output_full: value.isOutputFull,
    memo: value.lendMemo,
    batch_type: value.batchType
  }
}
